module.exports = __webpack_public_path__ + "img/header-engagementRingsSolitaire@2x.6b41164.webp";